import React, { FC, useState, HTMLAttributes } from "react";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import styles from "./ActionMenu.module.sass";
import { ReactComponent as TrashCan } from "images/TrashCan.svg";
import { ReactComponent as ActionMenuEdit } from "images/EditorIcon.svg";
import { ReactComponent as OpenEye } from "images/OpenEye.svg";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { deleteObject } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.thunks";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import classNames from "classnames";
import { Link, useParams } from "react-router-dom";
import { DeletingLine } from "../../BusinessProcesses/DeletingLine/DeletingLine";
import ConfirmNavigate from "components/ConfirmNavigate";
import { AddingAndEditionObject } from "../AddingAndEditionObject/AddingAndEditionObject";

interface ActionMenuProps extends HTMLAttributes<HTMLDivElement> {
	obj: any;
	timer: any;
}

export const ActionMenu: FC<ActionMenuProps> = ({ className, obj }) => {
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const [desireDelete, setDesireDelete] = useState<boolean>(false);
	const [confirmAction, setConfirmAction] = useState<boolean>(false);
	const { organizationId } = useParams();
	const dispatch = useAppDispatch();
	const { lastPart, searchMode, lastSearchedPart, searchValue } = useAppSelector((state) => state.objectsRegister);
	const deleteHandler = () => {
		dispatch(
			deleteObject({
				objId: obj.id,
				searchMode,
				orgId: Number(organizationId),
				part: searchMode ? lastSearchedPart : lastPart,
				quantity: 50,
				searchValue,
			}),
		);
		// timer(()=>dispatch(deleteObject(obj.id)));
	};

	const clickHandler = (callBack: () => void) => {
		if (obj.repeatable) setConfirmAction(true);
		else callBack();
	};

	const confirmClick = () => {
		setModalWindow(true);
		setConfirmAction(false);
	};

	return (
		<>
			{desireDelete && (
				<ModalWindow close={() => setDesireDelete(false)}>
					<DeletingLine
						close={() => setDesireDelete(false)}
						closeAll={() => setDesireDelete(false)}
						toDelete={deleteHandler}
						title={"Удалить объект?"}
					/>
				</ModalWindow>
			)}
			{modalWindow && (
				<ModalWindow close={() => setModalWindow(false)} width={"big"}>
					<AddingAndEditionObject type="edit" object={obj} close={() => setModalWindow(false)} />
				</ModalWindow>
			)}
			<ConfirmNavigate toggle={confirmAction} close={() => setConfirmAction(false)} clickHandler={confirmClick} />
			<div className={styles["menu-wrp"]}>
				<button className={styles["menu-btn"]}>
					<div>
						<ActionMenuIcon />
					</div>
				</button>
				<div onClick={(e) => e.stopPropagation()} className={classNames(styles.menu, className)}>
					<button onClick={() => clickHandler(() => setModalWindow(true))} className={styles["menu-item"]}>
						<div>
							<ActionMenuEdit />
						</div>
						<span className={styles["menu-item-txt"]}>Редактировать</span>
					</button>
					<Link
						className={styles["menu-item"]}
						to={`/categorization/organizations/${organizationId}/steps/2.2/info`}
						state={{ id: obj.id, name: obj.name }}>
						<div>
							<OpenEye />
						</div>
						<span className={styles["menu-item-txt"]}>Посмотреть доп. сведения об объекте</span>
					</Link>
					<button onClick={() => setDesireDelete(true)} className={styles["menu-item"]}>
						<div>
							<TrashCan className={styles.trashCan} />
						</div>
						<span className={styles["menu-item-txt"]}>Удалить</span>
					</button>
				</div>
			</div>
		</>
	);
};
